class LayeringRitual extends HTMLElement {
  connectedCallback() {
    this.cards = Array.from(this.querySelectorAll('[data-layering-card]'));
    this.hero = this.querySelector('[data-layering-hero]');
    this.heroLink = this.querySelector('[data-layering-hero-link]');
    this.hiddenInputs = Array.from(this.querySelectorAll('input[name="id"]'));
    this.quantityInput = this.querySelector('[data-layering-quantity]');
    this.stock = this.querySelector('[data-layering-stock]');
    this.notesTitle = this.querySelector('[data-layering-notes-title]');
    this.notesBody = this.querySelector('[data-layering-notes-body]');
    this.mobileButton = this.querySelector('[data-layering-mobile-submit]');
    this.form = this.querySelector('[data-layering-form]');
    this.moodButtons = Array.from(this.querySelectorAll('[data-layering-mood]'));

    this.cards.forEach((card) => {
      card.addEventListener('click', () => this.select(card));
      card.addEventListener('keydown', (event) => this.onCardKeydown(event, card));
    });

    this.querySelectorAll('[data-layering-qty]').forEach((button) => {
      button.addEventListener('click', () => this.adjustQuantity(button.dataset.layeringQty === 'plus' ? 1 : -1));
    });

    this.moodButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const matchingCard = this.cards.find((card) => card.dataset.noteKey === button.dataset.layeringMood);
        if (matchingCard) this.select(matchingCard);
      });
    });

    if (this.mobileButton && this.form) {
      this.mobileButton.addEventListener('click', () => {
        if (typeof this.form.requestSubmit === 'function') {
          this.form.requestSubmit();
        } else {
          this.form.submit();
        }
      });
    }

    const defaultCard = this.cards.find((card) => card.dataset.default === 'true') || this.cards[0];
    if (defaultCard) this.select(defaultCard, { replaceUrl: false });
  }

  select(card, options = {}) {
    const { replaceUrl = true } = options;
    const variantId = card.dataset.variantId;

    this.cards.forEach((item) => {
      const selected = item === card;
      item.classList.toggle('is-selected', selected);
      item.setAttribute('aria-checked', selected ? 'true' : 'false');
      item.tabIndex = selected ? 0 : -1;
    });

    this.hiddenInputs.forEach((input) => {
      input.value = variantId;
    });

    if (this.hero) {
      this.hero.src = card.dataset.image;
      this.hero.alt = card.dataset.alt;
    }

    if (this.heroLink) {
      this.heroLink.href = card.dataset.image;
    }

    if (this.notesTitle) this.notesTitle.textContent = card.dataset.pairing;
    if (this.notesBody) {
      const notesTemplate = this.querySelector(`[data-layering-notes-template="${card.dataset.noteKey}"]`);
      this.notesBody.innerHTML = notesTemplate ? notesTemplate.innerHTML : '';
    }

    this.moodButtons.forEach((button) => {
      button.classList.toggle('is-active', button.dataset.layeringMood === card.dataset.noteKey);
    });

    if (this.stock) {
      this.stock.textContent = card.dataset.available === 'true' ? 'In stock and ready for dispatch' : 'Currently unavailable';
      this.stock.classList.toggle('is-unavailable', card.dataset.available !== 'true');
    }

    const submitButtons = this.querySelectorAll('[type="submit"], .shopify-payment-button__button');
    submitButtons.forEach((button) => {
      button.disabled = card.dataset.available !== 'true';
    });

    if (replaceUrl && window.history && window.URLSearchParams) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variantId);
      window.history.replaceState({}, '', url.toString());
    }
  }

  onCardKeydown(event, card) {
    const index = this.cards.indexOf(card);
    const keyMap = {
      ArrowRight: 1,
      ArrowDown: 1,
      ArrowLeft: -1,
      ArrowUp: -1
    };

    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.select(card);
      return;
    }

    if (keyMap[event.key]) {
      event.preventDefault();
      const nextIndex = (index + keyMap[event.key] + this.cards.length) % this.cards.length;
      this.cards[nextIndex].focus();
      this.select(this.cards[nextIndex]);
    }
  }

  adjustQuantity(delta) {
    if (!this.quantityInput) return;
    const min = Number(this.quantityInput.min || 1);
    const max = this.quantityInput.max ? Number(this.quantityInput.max) : Infinity;
    const current = Number(this.quantityInput.value || min);
    const next = Math.max(min, Math.min(max, current + delta));
    this.quantityInput.value = next;
    this.querySelectorAll('input[name="quantity"]').forEach((input) => {
      input.value = next;
    });
  }
}

if (!customElements.get('layering-ritual')) {
  customElements.define('layering-ritual', LayeringRitual);
}
